import { z } from 'zod'

import { REQUIRED_ACTION_CATEGORIES, REQUIRED_ACTION_TYPES } from './requiredActionTypes'
const SearchLocationSchema = z.object({
  address: z
    .object({
      city: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
      country: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
      postalCode: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
      street: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
      streetNumber: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
    })
    .nullish()
    .transform((data) => data ?? undefined),
  port: z
    .object({
      name: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
      iataCode: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
    })
    .nullish()
    .transform((data) => data ?? undefined),
})

export const RequiredActionSchema = z.object({
  id: z.string(),
  entityId: z.string(),
  entityType: z.enum(['shipment', 'booking']),
  active: z.boolean(),
  category: z
    .enum(REQUIRED_ACTION_CATEGORIES)
    .nullish()
    .transform((data) => data ?? undefined),
  completed: z.boolean(),
  completedBy: z
    .object({}) // TODO: Refine
    .nullish()
    .transform((data) => data ?? undefined),
  customerReferenceDate: z
    .object({
      reference: z.string(),
      daysFromReference: z.number(),
    })
    .nullish()
    .transform((data) => data ?? undefined),
  description: z.string(),
  hiddenFromCustomer: z.boolean(),
  type: z.enum(REQUIRED_ACTION_TYPES),
  customerDueDate: z.coerce
    .date()
    .nullish()
    .transform((data) => data ?? undefined),
  critical: z
    .boolean()
    .nullish()
    .transform((data) => data ?? false),
  origin: SearchLocationSchema.nullish().transform((data) => data ?? undefined),
  destination: SearchLocationSchema.nullish().transform((data) => data ?? undefined),
})

export type RequiredAction = z.infer<typeof RequiredActionSchema>
export type RequiredActionSearchLocation = z.infer<typeof SearchLocationSchema>
